export const HabitIcons = [
  // Time & Scheduling (100)
  '🕐',
  '🕑',
  '🕒',
  '🕓',
  '🕔',
  '🕕',
  '🕖',
  '🕗',
  '🕘',
  '🕙',
  '🕚',
  '🕛',
  '🕜',
  '🕝',
  '🕞',
  '🕟',
  '🕠',
  '🕡',
  '🕢',
  '🕣',
  '🕤',
  '🕥',
  '🕦',
  '🕧',
  '⏰',
  '⏱️',
  '⏲️',
  '⏳',
  '⌛',
  '⌚',
  '🕰️',
  '📅',
  '📆',
  '🗓️',
  '🗒️',
  '📋',
  '📝',
  '✏️',
  '✒️',
  '🖊️',
  '🖋️',
  '📌',
  '📍',
  '📎',
  '🖇️',
  '📏',
  '📐',
  '✂️',
  '🖍️',
  '🖌️',
  '🔖',
  '🏷️',
  '📑',
  '🔗',
  '📊',
  '📈',
  '📉',
  '🧮',
  '🔢',
  '🔣',
  '🔤',
  '🆎',
  '🆑',
  '🆒',
  '🆓',
  '🆔',
  '🆕',
  '🆖',
  '🆗',
  '🆘',
  '🆙',
  '🆚',
  '🈁',
  '🈂️',
  '🈚',
  '🈯',
  '🈲',
  '🈳',
  '🈴',
  '🈵',
  '🈶',
  '🈷️',
  '🈸',
  '🈹',
  '🈺',
  '🉐',
  '🉑',
  '🌀',
  '🌁',
  '🌂',
  '🌃',
  '🌄',
  '🌅',
  '🌆',
  '🌇',
  '🌈',
  '🌉',
  '🌊',
  '🌋',
  '🌌',

  // Daily Routine (100)
  '🛏️',
  '🛌',
  '🛋️',
  '🚿',
  '🛁',
  '🚽',
  '🧻',
  '🧼',
  '🪥',
  '🧴',
  '🧽',
  '🪒',
  '💈',
  '🛍️',
  '🛒',
  '🎁',
  '🎀',
  '🎊',
  '🎉',
  '🎈',
  '🪩',
  '🪅',
  '🪆',
  '🧸',
  '🎎',
  '🎏',
  '🎐',
  '🪭',
  '🪮',
  '🧶',
  '🧵',
  '🪡',
  '🪢',
  '🧥',
  '🥼',
  '🦺',
  '👚',
  '👕',
  '👖',
  '🩲',
  '🩳',
  '👔',
  '👗',
  '👙',
  '👘',
  '🥻',
  '🩱',
  '🩴',
  '🥿',
  '👠',
  '👡',
  '👢',
  '👞',
  '👟',
  '🥾',
  '🥿',
  '🧦',
  '🧤',
  '🧣',
  '🎩',
  '🧢',
  '👒',
  '🎓',
  '⛑️',
  '🪖',
  '👑',
  '💍',
  '💎',
  '💄',
  '👓',
  '🕶️',
  '🥽',
  '🌂',
  '🧳',
  '☂️',
  '🧵',
  '🧶',
  '🪡',
  '🪢',
  '🧵',
  '🧶',
  '🪡',
  '🪢',
  '🧷',
  '📿',
  '💊',
  '💉',
  '🩹',
  '🩺',
  '🚪',
  '🪟',
  '🪞',
  '🛋️',
  '🛏️',
  '🛌',
  '🛁',
  '🚿',
  '🚽',
  '🧻',
  '🧼',

  // Work & Productivity (100)
  '💼',
  '📁',
  '📂',
  '🗂️',
  '📊',
  '📈',
  '📉',
  '✅',
  '✔️',
  '🎯',
  '🏆',
  '⭐',
  '🌟',
  '✨',
  '🔥',
  '🚀',
  '💪',
  '🧠',
  '🔋',
  '⚡',
  '💡',
  '🔦',
  '🕯️',
  '🧯',
  '🛠️',
  '🔧',
  '🔨',
  '⚒️',
  '🛡️',
  '🔒',
  '🔓',
  '🔏',
  '🔐',
  '🔑',
  '🗝️',
  '⚙️',
  '🔩',
  '⚗️',
  '🧪',
  '🧫',
  '🧬',
  '🔬',
  '🔭',
  '📡',
  '💻',
  '🖥️',
  '🖨️',
  '⌨️',
  '🖱️',
  '🖲️',
  '💽',
  '💾',
  '💿',
  '📀',
  '📼',
  '📷',
  '📸',
  '📹',
  '🎥',
  '📽️',
  '🎞️',
  '📞',
  '☎️',
  '📟',
  '📠',
  '📺',
  '📻',
  '🎙️',
  '🎚️',
  '🎛️',
  '🧭',
  '⏱️',
  '⏲️',
  '⏰',
  '🕰️',
  '⌛',
  '⏳',
  '📅',
  '📆',
  '🗓️',
  '📋',
  '📝',
  '✏️',
  '🖊️',
  '🖋️',
  '📌',
  '📍',
  '📎',
  '🖇️',
  '📏',
  '📐',
  '✂️',
  '🗃️',
  '🗄️',
  '🗑️',
  '📦',
  '📫',
  '📪',
  '📬',
  '📭',

  // Health & Fitness (100)
  '💧',
  '🍎',
  '🥦',
  '🥗',
  '🍌',
  '🥛',
  '🍵',
  '☕',
  '🍽️',
  '🥣',
  '🥤',
  '🧃',
  '🧉',
  '🍶',
  '🍾',
  '🍷',
  '🍸',
  '🍹',
  '🍺',
  '🍻',
  '🥂',
  '🥃',
  '🧊',
  '🥢',
  '🍴',
  '🥄',
  '🔪',
  '🍽️',
  '🧂',
  '🥫',
  '🍱',
  '🍘',
  '🍙',
  '🍚',
  '🍛',
  '🍜',
  '🍝',
  '🍠',
  '🍢',
  '🍣',
  '🍤',
  '🍥',
  '🥮',
  '🍡',
  '🥟',
  '🥠',
  '🥡',
  '🦪',
  '🍦',
  '🍧',
  '🍨',
  '🍩',
  '🍪',
  '🎂',
  '🍰',
  '🧁',
  '🥧',
  '🍫',
  '🍬',
  '🍭',
  '🍮',
  '🍯',
  '🏃',
  '🏃‍♂️',
  '🏃‍♀️',
  '🚶',
  '🚶‍♂️',
  '🚶‍♀️',
  '🧍',
  '🧎',
  '🏋️',
  '🏋️‍♂️',
  '🏋️‍♀️',
  '🤸',
  '🤸‍♂️',
  '🤸‍♀️',
  '🤼',
  '🤼‍♂️',
  '🤼‍♀️',
  '🤽',
  '🤽‍♂️',
  '🤽‍♀️',
  '🤾',
  '🤾‍♂️',
  '🤾‍♀️',
  '⛹️',
  '⛹️‍♂️',
  '⛹️‍♀️',
  '🤺',
  '🤾',
  '🧘',
  '🧘‍♂️',
  '🧘‍♀️',
  '🏄',
  '🏄‍♂️',
  '🏄‍♀️',
  '🚣',
  '🚣‍♂️',
  '🚣‍♀️',
  '🏊',

  // Sports & Activities (100)
  '⚽',
  '🏀',
  '🏈',
  '⚾',
  '🥎',
  '🏐',
  '🏉',
  '🥏',
  '🎱',
  '🪀',
  '🏓',
  '🏸',
  '🏒',
  '🏑',
  '🥍',
  '🏏',
  '🥅',
  '⛳',
  '🪁',
  '🏹',
  '🎣',
  '🥊',
  '🥋',
  '🎽',
  '🛹',
  '🛼',
  '🛷',
  '⛸️',
  '🥌',
  '🎿',
  '⛷️',
  '🏂',
  '🪂',
  '🏋️',
  '🤼',
  '🤸',
  '⛹️',
  '🤺',
  '🤾',
  '🏌️',
  '🏇',
  '🧗',
  '🧗‍♂️',
  '🧗‍♀️',
  '🚵',
  '🚵‍♂️',
  '🚵‍♀️',
  '🚴',
  '🚴‍♂️',
  '🚴‍♀️',
  '🏆',
  '🥇',
  '🥈',
  '🥉',
  '🏅',
  '🎖️',
  '🏵️',
  '🎗️',
  '🎫',
  '🎟️',
  '🎪',
  '🤹',
  '🤹‍♂️',
  '🤹‍♀️',
  '🎭',
  '🩰',
  '🎨',
  '🎬',
  '🎤',
  '🎧',
  '🎼',
  '🎹',
  '🥁',
  '🪘',
  '🎷',
  '🎺',
  '🪗',
  '🎸',
  '🪕',
  '🎻',
  '🪈',
  '🎲',
  '♟️',
  '🎯',
  '🎳',
  '🎮',
  '🎰',
  '🧩',
  '🪅',
  '🪆',
  '🪄',
  '🧿',
  '🪬',
  '🧸',
  '🛝',
  '🎠',
  '🎡',
  '🎢',
  '🚂',
  '🚃',

  // Food & Nutrition (100)
  '🍇',
  '🍈',
  '🍉',
  '🍊',
  '🍋',
  '🍌',
  '🍍',
  '🥭',
  '🍎',
  '🍏',
  '🍐',
  '🍑',
  '🍒',
  '🍓',
  '🫐',
  '🥝',
  '🍅',
  '🫒',
  '🥥',
  '🥑',
  '🍆',
  '🥔',
  '🥕',
  '🌽',
  '🌶️',
  '🫑',
  '🥒',
  '🥬',
  '🥦',
  '🧄',
  '🧅',
  '🥜',
  '🌰',
  '🍞',
  '🥐',
  '🥖',
  '🫓',
  '🥨',
  '🥯',
  '🥞',
  '🧇',
  '🧀',
  '🍖',
  '🍗',
  '🥩',
  '🥓',
  '🍔',
  '🍟',
  '🍕',
  '🌭',
  '🥪',
  '🌮',
  '🌯',
  '🫔',
  '🥙',
  '🧆',
  '🥚',
  '🍳',
  '🥘',
  '🍲',
  '🫕',
  '🥣',
  '🥗',
  '🍿',
  '🧈',
  '🧂',
  '🥫',
  '🍱',
  '🍘',
  '🍙',
  '🍚',
  '🍛',
  '🍜',
  '🍝',
  '🍠',
  '🍢',
  '🍣',
  '🍤',
  '🍥',
  '🥮',
  '🍡',
  '🥟',
  '🥠',
  '🥡',
  '🦀',
  '🦞',
  '🦐',
  '🦑',
  '🦪',
  '🍦',
  '🍧',
  '🍨',
  '🍩',
  '🍪',
  '🎂',
  '🍰',
  '🧁',
  '🥧',
  '🍫',
  '🍬',

  // Cleaning & Organization (100)
  '🧹',
  '🧺',
  '🧽',
  '🪣',
  '🫧',
  '🚰',
  '🪠',
  '🚽',
  '🛁',
  '🚿',
  '🪞',
  '🪟',
  '🪑',
  '🛋️',
  '🛏️',
  '🪞',
  '🪟',
  '🪵',
  '🪨',
  '🪹',
  '🪺',
  '🧱',
  '🪤',
  '🪒',
  '🪮',
  '🪡',
  '🪢',
  '🧶',
  '🧵',
  '🪡',
  '🪢',
  '🧷',
  '📎',
  '📌',
  '📍',
  '🖇️',
  '📏',
  '📐',
  '✂️',
  '🗃️',
  '🗄️',
  '🗑️',
  '📦',
  '📫',
  '📪',
  '📬',
  '📭',
  '🗂️',
  '📁',
  '📂',
  '📒',
  '📓',
  '📔',
  '📕',
  '📗',
  '📘',
  '📙',
  '📚',
  '📖',
  '🔖',
  '🧾',
  '📋',
  '📝',
  '✏️',
  '🖊️',
  '🖋️',
  '✒️',
  '🖌️',
  '🖍️',
  '🧮',
  '🔢',
  '🔣',
  '🔤',
  '🔠',
  '🔡',
  '🔢',
  '🎀',
  '🎁',
  '🪄',
  '🧧',
  '🎊',
  '🎉',
  '🎈',
  '🪩',
  '🪅',
  '🪆',
  '🧸',
  '🎎',
  '🎏',
  '🎐',
  '🪭',
  '🪮',
  '🧶',
  '🧵',
  '🪡',
  '🪢',
  '🧥',
  '🥼',
  '🦺',
  '👚',

  // Learning & Study (25)
  '📚',
  '📖',
  '📕',
  '📗',
  '📘',
  '📙',
  '📒',
  '📔',
  '📓',
  '📃',
  '📜',
  '📄',
  '🗞️',
  '📰',
  '📑',
  '🔖',
  '🏷️',
  '💰',
  '💴',
  '💵',
  '💶',
  '💷',
  '💸',
  '🪙',
  '💎'
];

export const COMMON_EMOJIS = ['👍', '👎', '❤️', '😄', '😢', '🎉', '🤔', '👀'];

export const ICON_STROKE_WIDTH = {
  SMALL: 2,
  MEDIUM: 3,
  LARGE: 4
};
